/* eslint-disable react-hooks/exhaustive-deps */
import "./style.css";
import { useNavigate } from "react-router-dom";
import ReactDataTable from "../../Components/ReactDataTable";
import moment from "moment";
import ActionButton from "../../Components/ReactDataTable/ActionButton";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import {
  Box,
  List,
  Stack,
  Button,
  ButtonGroup,
  FormControlLabel,
  Typography,
  Checkbox,
} from "@mui/material";
import {
  CLEAR_PROGRAM_SUCCESS,
  getProgramPublishDetail,
  updateProgramStatus,
  searchProgram,
  updateProgramPublishStatus,
  RemoveProgram,
} from "../../Redux/Actions/ProgramAction";
import { useErrorHandler } from "../../hooks";
import HelmetReact from "../../Components/Helmet";
import ResponsiveDialog from "../../Components/DialogBox";
import { useLocation } from "react-router-dom";
import FilterComponent from "../../Components/ReactDataTable/FilterComponent";
import ReactLoading from "react-loading";
import { CLEAR_EXPLORE_DATA, CopyContent } from "../../Redux/Actions/ExploreAction";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";

export const Programs = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [model, setModel] = useState("Delete");
  const { user } = useSelector((state) => state?.Auth);
  const { copy_status } = useSelector((state) => state.Explore);
  const { success, loading, programList, totalCount } = useSelector(
    (state) => state.Program
  );
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [selectedTab, setSelectedTab] = useState("");
  const [tabNavigate, setTabNavigate] = useState(null);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const { setMsgConfig } = useErrorHandler();
  const location = useLocation();
  const [loaderTimeOut, setLoaderTimeOut] = useState(false);


  const [details, setDetails] = useState({ id: "", is_publish: false });

  let data;
  if (selectedTab === "PUBLISHED") {
    data = programList?.map((e) => e);
  } else if (selectedTab === "SANDBOX") {
    data = programList?.map((e) => e);
  } else if (selectedTab === "DRAFTS") {
    data = programList?.map((e) => e);
  }

  const [navigateUrl, setNavigateUrl] = useState("/programs/edit/");
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [itemId, setItemId] = useState();

  useEffect(() => {
    if (selectedTab === "PUBLISHED") {
      setNavigateUrl(`/programs/published/`);
    } else if (selectedTab === "SANDBOX") {
      setNavigateUrl(`/programs/sandbox/`);
    } else if (selectedTab === "DRAFTS") {
      setNavigateUrl(`/programs/drafts/`);
    }
  }, [selectedTab, programList]);

  useEffect(() => {
    location?.state
      ? setTabNavigate(location?.state)
      : user?.role === "admin"
      ? setTabNavigate("PUBLISHED")
      : setTabNavigate("SANDBOX");
  }, [location?.state, tabNavigate]);
  useEffect(() => {
    dispatch({ type: CLEAR_EXPLORE_DATA });
    if (copy_status) {
      setSelectedTab("SANDBOX");
    }
  }, [copy_status]);
  useEffect(() => {
    if (tabNavigate) {
      setSelectedTab(tabNavigate);
    }
  }, [tabNavigate]);

  useEffect(() => {
    setLoaderTimeOut(true);
    setTimeout(() => {
      setLoaderTimeOut(false);
    }, 500);
    if (user?.role === "admin") {
      setSelectedTab("PUBLISHED");
    } else {
      setSelectedTab("SANDBOX");
    }
  }, [user?.role]);
  useMemo(() => {
    if (success) {
      setLoaderTimeOut(false);
      navigate("/programs/create", { state: selectedTab });
    } else {
      setLoaderTimeOut(false);
    }
  }, [success]);
  const onTableChange = (filter) => {
    if (selectedTab === "PUBLISHED") {
      const searchPayload = {
        type: "publish",
        key: filterText || "",
        perPage: filter?.perpage || 10,
        page: filter?.page || 1,
        sortBy: filter?.sortBy || "id",
        sortDirection: filter?.direction || "DESC",
      };

      dispatch(searchProgram(searchPayload));
    } else if (selectedTab === "SANDBOX") {
      const searchPayload = {
        type: "sandbox",
        key: filterText || "",
        perPage: filter?.perpage || 10,
        page: filter?.page || 1,
        sortBy: filter?.sortBy || "id",
        sortDirection: filter?.direction || "DESC",
      };

      dispatch(searchProgram(searchPayload));
    } else if (selectedTab === "DRAFTS") {
      const searchPayload = {
        type: "draft",
        key: filterText || "",
        perPage: filter?.perpage || 10,
        page: filter?.page || 1,
        sortBy: filter?.sortBy || "id",
        sortDirection: filter?.direction || "DESC",
      };

      dispatch(searchProgram(searchPayload));
    }
  };
  const handleConfirm = () => {
    const payload = {
      Id: itemId,
    };

    dispatch(RemoveProgram(payload));
    setIsVisibleModal(false);
    setMsgConfig({
      alertOpen: true,
      message: "Remove Program SuccessFully!!",
      severity: "success",
      autoHideDuration: 1000,
    });
  };
  const handleAllow = () => {
    setIsVisibleModal(false);
    setModel("Delete");
    handleStatus(true);
    //called api for notification allow
  };
  const handleStatusChange = (item, value) => {
    if (value === "Delete") {
      setIsVisibleModal(true);
      setItemId(item?.id);
    } else {
      const payload = {
        Id: item?.id,
        is_active: value,
      };
      dispatch(updateProgramStatus(payload));
      setMsgConfig({
        alertOpen: true,
        message: "Program Status Update SuccessFully!!",
        severity: "success",
        autoHideDuration: 2000,
      });
    }
  };

  useEffect(() => {
    onTableChange();
  }, [selectedTab, filterText, copy_status]);

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    return (
      <FilterComponent
        onFilter={(e) => setFilterText(e)}
        onClear={handleClear}
        filterText={filterText}
        placeHolder="Search by title"
      />
    );
  }, [filterText, resetPaginationToggle]);
  const goToDetailScreen = (id) => {
    dispatch({ type: CLEAR_PROGRAM_SUCCESS });
    dispatch(getProgramPublishDetail(id?.id));
    setLoaderTimeOut(true);
    // navigate("/programs/create", { state: selectedTab });
  };
  useEffect(() => {
    dispatch({ type: CLEAR_PROGRAM_SUCCESS });
  }, []);
  const RemoveItem = (item) => {
    setIsVisibleModal(true);
    setItemId(item?.id);
  };
  const handleStatus = (notify) => {
    const payload = {
      Id: details.id,
      is_publish: details.is_publish,
      is_notify: notify,
    };
    dispatch(updateProgramPublishStatus(payload));
    setMsgConfig({
      alertOpen: true,
      message: "Program Published Successfully",
      severity: "success",
      autoHideDuration: 20000,
    });
  };
  // const handleStatus = (e, id) => {
  //   const payload = {
  //     Id: id,
  //     is_publish: e.target.checked,
  //   };
  //   dispatch(updateProgramPublishStatus(payload));
  //   setMsgConfig({
  //     alertOpen: true,
  //     message: "Program Published Successfully",
  //     severity: "success",
  //     autoHideDuration: 20000,
  //   });
  // };
  const columns = [
    {
      name: "DUPLICATE",
      center: true,
      omit: selectedTab !== "DRAFTS" ? false : true,
      cell: (row) => {
        return (
          <Box sx={{ cursor: "pointer" }}>
            <ContentCopyOutlinedIcon
              onClick={() => {
                const payload = {
                  content_id: row.id,
                  type: "program",
                };
                if (row) {
                  dispatch(CopyContent(payload));
                }
                //Called api for copied program data
              }}
            />
          </Box>
        );
      },
    },
    {
      name: "TITLE",
      sortField: "title",
      selector: (row) => row.title,
      sortable: true,
      center: true,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>{row.title}</span>
          </span>
        );
      },
    },
    {
      name: "CONTRIBUTOR",
      id: "contributor_name",
      sortField: "contributor_name",
      selector: (row) => row.contributor_name,
      sortable: true,
      center: true,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>{row.contributor_name}</span>
          </span>
        );
      },
    },
    {
      name: "DURATION",
      sortField: "duration",
      sortable: true,
      selector: (row) => row.duration,
      center: true,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>{row.duration + " Weeks"}</span>
          </span>
        );
      },
    },
    {
      name: "DATE CREATED",
      sortField: "created_at",
      sortable: true,
      center: true,
      selector: (row) => row.created_at,
      cell: (row) => {
        return (
          <span className="badge bg-light-danger">
            <span>
              {row.created_at
                ? moment(row.created_at).format("DD/MM/YYYY")
                : "N/A"}
            </span>
          </span>
        );
      },
    },
    {
      name: "STATUS",
      sortField: "is_publish",
      selector: (row) => row?.is_publish,
      omit:
        (selectedTab === "PUBLISHED" || selectedTab === "SANDBOX") &&
        (user?.role === "admin" || userData?.role === "admin")
          ? false
          : true,
      width: "250px",
      center: true,
      style: { width: "100px", "margin-left": "20px" },
      cell: (row) => {
        return (
          <div className="badge bg-light-danger">
            <Typography>Published</Typography>
            <br />
            <FormControlLabel
              control={<Checkbox checked={row.is_publish} />}
              onChange={(e) => {
                setDetails({
                  id: row.id,
                  is_publish: e.target.checked,
                });
                if (row.is_publish) {
                  dispatch(
                    updateProgramPublishStatus({
                      Id: row.id,
                      is_publish: e.target.checked,
                    })
                  );
                  setMsgConfig({
                    alertOpen: true,
                    message: "Program Published Successfully",
                    severity: "success",
                    autoHideDuration: 20000,
                  });
                } else {
                  setModel("Published");
                  setIsVisibleModal(true);
                }
              }}
            />
          </div>
        );
      },
    },
    {
      name: "PROGRAM STATUS",
      omit:
        selectedTab === "DRAFTS" || selectedTab === "PUBLISHED"
          ? true
          : selectedTab === "DRAFTS" && user?.role === "editor"
          ? true
          : user?.role === "editor" && selectedTab === "SANDBOX"
          ? true
          : user?.role === "editor" && selectedTab === "PUBLISHED"
          ? true
          : false,

      sortable: selectedTab === "SANDBOX" ? true : false,
      center: true,
      selector: (row) => row.is_active,
      sortField: "is_active",
      cell: (row) => {
        return (
          <>
            <Box sx={{ display: "flex", gap: "10px" }}>
              <span className="badge bg-light-danger">
                <span className="status">
                  {row.is_active ? "Active" : "Inactive"}
                </span>
              </span>
              <span className="status-icon-btn view-detail-btn">
                <ActionButton
                  isUpdateIcon={true}
                  handleStatusChange={handleStatusChange}
                  item={row}
                  isEditMode={true}
                />
              </span>
            </Box>
          </>
        );
      },
    },
    {
      name: "ACTION",
      right: true,
      // omit: selectedTab !== "PUBLISHED" ? false : true,
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      center: true,
      cell: (row) => {
        return (
          <>
              <span className="edit-icon-btn view-detail-btn">
                <ActionButton
                  isEditIcon={true}
                  goToDetailScreen={goToDetailScreen}
                  item={row}
                  isEditMode={true}
                />
              </span>
             {user?.role === "editor" || user?.role === "doctor" || selectedTab === "PUBLISHED" ? (
              false
            ) : (
              <span className="remove-icon-btn view-detail-btn">
                <ActionButton
                  isRemoveIcon={true}
                  RemoveItem={RemoveItem}
                  item={row}
                  isEditMode={true}
                />
              </span>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <ResponsiveDialog
        dtype={model === "Published" ? "permission" : "confirm"}
        open={isVisibleModal}
        header={
          model === "Published"
            ? "Do you want to notify users of publishing?"
            : "Are you sure you want to delete this program?"
        }
        onConfirm={() =>
          model === "Published" ? handleAllow() : handleConfirm()
        }
        onClose={() => {
          if (model === "Published") {
            setModel("Delete");
            handleStatus(false);
          }
          setIsVisibleModal(false);
        }}
      ></ResponsiveDialog>
      <HelmetReact name="Program" />
      <Box className="d-details-box">
        <ButtonGroup variant="text" aria-label="text button group">
          {user?.role === "admin" && (
            <Button
              className={`${selectedTab === "PUBLISHED" ? "active" : ""}`}
              onClick={() => {
                setLoaderTimeOut(true);
                setTimeout(() => {
                  setLoaderTimeOut(false);
                }, 1000);
                setSelectedTab("PUBLISHED");
                setFilterText("");
              }}
            >
              PUBLISHED
            </Button>
          )}

          <Button
            className={`${selectedTab === "SANDBOX" ? "active" : ""}`}
            onClick={() => {
              setLoaderTimeOut(true);
              setTimeout(() => {
                setLoaderTimeOut(false);
              }, 1000);
              setSelectedTab("SANDBOX");
              setFilterText("");
            }}
          >
            SANDBOX
          </Button>
          <Button
            className={`${selectedTab === "DRAFTS" ? "active" : ""}`}
            onClick={() => {
              setLoaderTimeOut(true);
              setTimeout(() => {
                setLoaderTimeOut(false);
              }, 1000);
              setSelectedTab("DRAFTS");
              setFilterText("");
            }}
          >
            DRAFTS
          </Button>
        </ButtonGroup>
        <List component={Stack} direction="row"></List>
        <Box
          sx={{
            textAlign: "right",
          }}
        >
          <Button
            sx={{
              background: "#000",
              marginBottom: "15px",
              borderRadius: "70px",
            }}
            variant="contained"
            onClick={(e) => {
              e.stopPropagation();
              dispatch({ type: CLEAR_PROGRAM_SUCCESS });
              navigate("/programs/create");
            }}
          >
            CREATE PROGRAM
          </Button>
        </Box>
        {loaderTimeOut ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 15,
            }}
          >
            <ReactLoading
              type="cylon"
              height="80px"
              width="80px"
              color="#39a2e8"
            />
          </Box>
        ) : (
          <ReactDataTable
            columns={columns}
            items={data}
            onChange={onTableChange}
            totalRows={totalCount}
            isLoading={loading}
            navigateUrl={navigateUrl}
            isShowSearch={true}
            paginationResetDefaultPage={resetPaginationToggle}
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
          />
        )}
      </Box>
    </>
  );
};
